module.exports = __webpack_public_path__ + "static/img/index_bg_3.811e4fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_3.jpg
// module id = 4CKf
// module chunks = 9